import $vuetify from 'vuetify/es5/locale/zh-Hant'

export default {
	fileName: '檔案名稱',
	modifiedTime: '修改時間',
	fileSize: '檔案大小',
	mainDrive: '主要硬碟',
	search: '搜尋',
	fileUpload: '檔案上傳',
	urlUpload: '從網址上傳',
	upload: '上傳',
	fileToUpload: '要上傳的檔案',
	uploading: '上傳中...',
	serverProcessing: '伺服器正在處理檔案',
	bigFileUploadWarning:
		'由於 CloudFlare Workers 的限制，上傳大檔案可能會隨機失敗',
	$vuetify,
}
